import { analytics } from '@/shared/services/analytics'
import { useToast, type ToastVariant } from '@dacr/library'
import { defineStore } from 'pinia'

export enum ToastType {
  Default = 'default',
  Success = 'success',
  Warning = 'warning',
  Error = 'error',
}

interface Toast {
  type: ToastType
  content: string
  timeout?: number
  error?: Error
}

const variantByType: Record<ToastType, ToastVariant> = {
  [ToastType.Default]: 'light',
  [ToastType.Success]: 'success',
  [ToastType.Warning]: 'light',
  [ToastType.Error]: 'error',
}

export const useToastStore = defineStore('toast', () => {
  const toast = useToast()

  const showToast = (data: Toast) => {
    toast.show({
      variant: variantByType[data.type],
      message: data.content,
      duration: data.timeout || 3000,
    })

    if (data.error) {
      analytics.captureException(data.error)
    }
  }

  const hideToast = () => toast.dismiss()

  return {
    showToast,
    hideToast,
  }
})
